import { Menu } from "antd";
import React from "react";

import Icon, { AppstoreOutlined, BarChartOutlined, BellOutlined, FileTextOutlined, ImportOutlined, ProfileOutlined, SettingOutlined, UserOutlined, FolderOpenOutlined, BlockOutlined, PlaySquareOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import useTranslation from "../customHooks/translations";
import { HrSVG, ReelsSVG } from "./Menu";
import { canAccessMenu } from "../pages/Auth/PermissionType";
import { useSelector } from "react-redux";

function MenuSide({ onTitleChange }) {
  const location = useLocation();

  const translation = useTranslation();
  const navigate = useNavigate();
  const authSelector = useSelector((state) => state.auth.auth);

  const permissionFuc = (arr) => canAccessMenu(authSelector.role, arr.key);

  return (
    <Menu
      style={{ border: 0,justifyContent :'center',display:'flex',flexDirection:'column',height:'100%',padding:10,margin:0,borderRadius:10}}
      className="menu-side-test"
      selectedKeys={[location.pathname.split("/")[1]]}
      defaultSelectedKeys={["/"]}
      mode="inline"
      items={[
        
        {
          key: "Patient",
          icon: <UserOutlined />,
          label: translation.patient,
          className: "menu-item-test",
          onClick: () => {
            navigate("/Patient");
            onTitleChange(translation.patient);
          },
        },
       
        {
          key: "Note",
          icon: <FileTextOutlined />,
          label: translation.Note,
          className: "menu-item-test",
          onClick: () => {
            navigate("/Note");
            onTitleChange("تێبینی");
          },
         
        },

        {
          key: "LabPage",
          icon: <ProfileOutlined />,
          label: translation.lab,
          className: "menu-item-test",
          onClick: () => {
            navigate("/LabPage");
            onTitleChange(translation.lab);
          },
        },
        {
          key: "Cliche",
          icon: <ImportOutlined />,
          label: "کڵێشە",
          className: "menu-item-test",
          onClick: () => {
            navigate("/Cliche");
            onTitleChange("کڵێشە");
          },
        },

        // {
        //   key: "Tutorial",
        //   icon: <BulbOutlined />,
        //   label: "فێرکاری",
        //   className: "menu-item-test",
        //   onClick: () => {
        //     navigate("/Tutorial");
        //     onTitleChange("فێرکاری");
        //   },
        // },

        {
          key: "HR",
          icon: <Icon component={HrSVG} />,
          label: "بەڕێوبردنی کارمەند",
          className: "menu-item-test",
          onClick: () => {
            navigate("/HR");
            onTitleChange(translation.Report);
          },
        },

        {
          key: "Report",
          icon: <BarChartOutlined />,
          label: "ڕاپۆرت",
          className: "menu-item-test",
          onClick: () => {
            navigate("/Report");
            onTitleChange("ڕاپۆرت");
          },
        },

        {
          key: "Application",
          icon: <AppstoreOutlined />,
          className: "menu-item-test",
          label: "ئەپپڵیکەیشن",
          children: [
            {
              key: "Notify",
              label: "ئاگادارکردنەوە",
              icon: <BellOutlined />,
              className: "menu-item-test",
              onClick: () => {
                navigate("/Notify");
                onTitleChange("ئاگادارکردنەوە");
              },
            },
            {
              key: "Reels",
              label: "ڕییــڵز",
              icon: <Icon component={ReelsSVG} />,
              className: "menu-item-test",
              onClick: () => {
                navigate("/Reels");
                onTitleChange("ڕییــڵز");
              },
            },
            {
              key: "Camparission",
              label: "کارەکان",
              icon: <FolderOpenOutlined  />,
              className: "menu-item-test",
              onClick: () => {
                navigate("/Camparission");
                onTitleChange("کارەکان");
              },
            },
            {
              key: "Blog",
              label: "بڵۆگەکان",
              icon: <BlockOutlined />  ,
              className: "menu-item-test",
              onClick: () => {
                navigate("/Blog");
                onTitleChange("بڵۆگەکان");
              },
            },
            {
              key: "FAQ",
              label: "پرسیارە باوەکان",
              icon: <QuestionCircleOutlined />  ,
              className: "menu-item-test",
              onClick: () => {
                navigate("/FAQ");
                onTitleChange("پرسیارە باوەکان");
              },
            },
            {
              key: "InstructionVideos",
              label: "ڕێنمایی ڤیدیۆ",
              icon: <PlaySquareOutlined />  ,
              className: "menu-item-test",
              onClick: () => {
                navigate("/InstructionVideos");
                onTitleChange("ڕێنمایی ڤیدیۆ");
              },
            },
            {
              key: "InstructionText",
              label: "ڕێنمایی بە نووسین",
              icon: <PlaySquareOutlined />  ,
              className: "menu-item-test",
              onClick: () => {
                navigate("/InstructionText");
                onTitleChange("ڕێنمایی بە نووسین");
              },
            },
          ],
        },

        {
          key: "Settings",
          icon: <SettingOutlined />,
          label: translation.Settings,
          className: "menu-item-test",
          onClick: () => {
            navigate("/Settings");
            onTitleChange(translation.Settings);
          },
        },
      ].filter(permissionFuc)}
    />
  );
}

export default MenuSide;
